<template>
  <v-dialog
    v-model="dialog"
    :transition="false"
    :persistent="pending"
    @click:outside="!pending ? cancel() : () => {}"
    :max-width="maxWidth"
  >
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        <slot>
          <div v-if="description">{{ description }}</div>
        </slot>
      </v-card-text>
      <v-card-actions>
        <slot
          name="actions"
          :cancel="cancel"
          :confirm="confirm"
          :close="close"
          :pending="pending"
        >
          <v-spacer/>
          <v-btn
            text
            color="grey darken-2"
            :disabled="pending"
            @click="cancel()"
          >
            отмена
          </v-btn>
          <v-btn
            text
            color="error darken-2"
            :disabled="pending"
            :loading="pending"
            @click="confirm()"
          >
            {{confirmText}}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    title: {
      type: String,
      default: 'Требуется подтверждение' // @review: should be translatable
    },
    description: {
      type: String,
      default: null
    },
    maxWidth: {
      type: [Number, String],
      default: 400
    },
    confirmText: {
      type: String,
      default: 'Подтвердить'
    }
  },
  data () {
    return {
      dialog: false,
      payload: null,
      awaitCallback: false,
      awaitingCallback: false,
      resolve: () => {},
      reject: () => {}
    }
  },
  computed: {
    pending () {
      return this.awaitingCallback
    }
  },
  watch: {
    dialog (val) {
      if (!val) this.payload = null
    }
  },
  methods: {
    open (payload, awaitCallback = false) {
      this.payload = payload
      this.awaitCallback = awaitCallback
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    close () {
      this.awaitingCallback = false
      this.dialog = false
    },
    confirm () {
      if (this.awaitCallback) this.awaitingCallback = true
      this.resolve({
        payload: this.payload,
        cb: () => {
          this.close()
        }
      })
      if (!this.awaitCallback) this.close()
    },
    cancel () {
      this.reject({ cancel: true })
      this.close()
    }
  }
}
</script>
